import type { ReactNode } from 'react'
import { Icon } from './Icon'

// Right-side slide-in drawer shell (backdrop + header + body + footer). Shared by the Gateways and Accounts
// config forms. Close via the ✕ or a backdrop click.
export function DrawerShell({
  title,
  onClose,
  children,
  foot,
}: {
  title: string
  onClose: () => void
  children: ReactNode
  foot: ReactNode
}) {
  return (
    <>
      <div className="backdrop" onClick={onClose} />
      <div className="drawer" role="dialog" aria-label={title}>
        <div className="drawer-head">
          <b>{title}</b>
          <button className="icon-btn" onClick={onClose} aria-label="Close">
            <Icon name="close" size={16} />
          </button>
        </div>
        <div className="drawer-body">{children}</div>
        <div className="drawer-foot">{foot}</div>
      </div>
    </>
  )
}
